import React, { useState, useEffect, useRef } from 'react';
// import '../App.css'; // COMMENTED OUT: Caused compilation error (Could not resolve)
// import article from '../assets/artical.jpg'; // COMMENTED OUT: Caused compilation error (Could not resolve)

// Placeholder variable for the missing 'article' image import
const article = [
  require('../assets/edb-advisory.webp'),
  require('../assets/LR Post .webp'),
  


];

const AdPreloader = ({ onAdEnd }) => {
  const adDuration = 25; // seconds
  const [timeLeft, setTimeLeft] = useState(adDuration);
  const [showSkipButton, setShowSkipButton] = useState(false);
  const [progressBarWidth, setProgressBarWidth] = useState(0);
  const [currentAdIndex, setCurrentAdIndex] = useState(0);
  const [isFlipping, setIsFlipping] = useState(false);

  const ads = [
    ...article,
    // '/images/advertisment2.jpeg',
    // '/images/advertisment1.jpg',
    // '/images/advertisment.jpeg',

  ];

  const timerIntervalRef = useRef(null);
  const shipRef = useRef(null);

  // Timer + skip logic
  useEffect(() => {
    const skipButtonTimeout = setTimeout(() => {
      setShowSkipButton(true);
    }, 2000);

    timerIntervalRef.current = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerIntervalRef.current);
          onAdEnd();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => {
      clearInterval(timerIntervalRef.current);
      clearTimeout(skipButtonTimeout);
    };
  }, [onAdEnd]);

  // Progress bar + ship movement
  useEffect(() => {
    // FIX START: Capture the current ref value to satisfy react-hooks/exhaustive-deps
    // This prevents the error: "The ref value 'shipRef.current' will likely have changed..."
    const currentShipElement = shipRef.current;

    const progressTimeout = setTimeout(() => {
      setProgressBarWidth(1000000);
    }, 0);

    // Use the captured variable for setup
    if (currentShipElement) {
      currentShipElement.style.animation = `moveShip ${adDuration}s linear forwards`;
    }

    return () => {
      clearTimeout(progressTimeout);
      // Use the captured variable for cleanup
      if (currentShipElement) {
        currentShipElement.style.animation = 'none';
      }
    };
    // FIX END
  }, [adDuration]); // Added adDuration to dependencies for completeness

  const handleSkipAd = () => {
    clearInterval(timerIntervalRef.current);
    onAdEnd();
  };

  // Flip animation when changing ads
  const handleNextAd = () => {
    setIsFlipping(true);
    setTimeout(() => {
      setCurrentAdIndex((prev) => (prev + 1) % ads.length);
      setIsFlipping(false);
    }, 500);
  };

  const handlePrevAd = () => {
    setIsFlipping(true);
    setTimeout(() => {
      setCurrentAdIndex((prev) => (prev - 1 + ads.length) % ads.length);
      setIsFlipping(false);
    }, 500);
  };

  return (
    <div className="ad-overlay">
      <div className={`ad-card ${isFlipping ? 'flip' : ''}`}>
        <img
          src={ads[currentAdIndex]}
          alt="Advertisement" // Added alt prop to fix ESLint warning
          className="ad-image"
        />
      </div>

      <div className="ad-controls">
        <button onClick={handlePrevAd} className="nav-button">⟵ Prev</button>
        <span className="ad-counter">
          Ad {currentAdIndex + 1} of {ads.length}
        </span>
        <button onClick={handleNextAd} className="nav-button">Next ⟶</button>
      </div>

      <div className="progress-bar-wrapper">
        <div
          className="progress-bar"
          style={{
            width: `${progressBarWidth}%`,
            transition: `width ${adDuration}s linear`
          }}
        ></div>
        <div className="ship-icon" ref={shipRef}>🚢</div>
      </div>

      <div className="skip-timer">
        <span id="adTimer">{timeLeft}</span> seconds remaining
      </div>

      <button
        onClick={handleSkipAd}
        className="skip-button"
        disabled={!showSkipButton}
      >
        Skip Ad
      </button>
    </div>
  );
};

export default AdPreloader;